/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useRef, CSSProperties, memo, useState } from 'react';

import { IoCloseSharp } from 'react-icons/io5';
import { toast } from 'react-toastify';
import { Toast } from 'react-toastify/dist/components';

import { useLoading } from '~/hooks/loading';
import { ExerciseService, TrainingStoreService } from '~/services';

import Button from '../Button';

import * as S from './styles';

type TAlignModal = 'flex-start' | 'center' | 'flex-end';
type ExLibraryModalType = 'addCategory' | 'addCategoryExercise';

type TScrollView = boolean;

interface IModalProps {
  modalVisible: boolean;
  setModalVisible(param: boolean): void;
  alignModal?: TAlignModal;
  scrollView?: TScrollView;
  containerStyle?: CSSProperties;
  title?: string;
  modalType: ExLibraryModalType;
  categoryName?: string;
}

export const TrainingStoreModal = memo(
  ({
    modalVisible = false,
    alignModal = 'center',
    scrollView = false,
    setModalVisible,
    title,
    containerStyle,
    modalType,
    categoryName,
  }: IModalProps): JSX.Element => {
    const { setLoading } = useLoading();

    const backdrop = useRef<HTMLDivElement>(null);
    const [newSegment, setNewSegment] = useState<string>(categoryName || '');
    const [newExercise, setNewExercise] = useState<string>();

    const handleModalVisible = useCallback(
      (e) => {
        if (e.target === backdrop.current) {
          setModalVisible(!modalVisible);
        }
      },
      [modalVisible, setModalVisible],
    );

    const handleClick = useCallback(async () => {
      setLoading(true);

      if (!newExercise) {
        toast.error('Preencha o Nome do exercício!');
        return;
      }
      await TrainingStoreService.addTrainingStores({
        category: newSegment,
        description: newExercise,
      });
      setModalVisible(!modalVisible);

      setLoading(false);
    }, [modalVisible, newExercise, newSegment, setModalVisible]);

    return (
      <>
        <S.BackdropContainer
          ref={backdrop}
          visible={modalVisible}
          alignModal={alignModal}
          onClick={handleModalVisible}
        >
          <S.Container
            alignModal={alignModal}
            scrollView={scrollView}
            style={containerStyle}
          >
            <S.Header>
              <S.HeaderTitle>{title}</S.HeaderTitle>
              <IoCloseSharp
                style={{ cursor: 'pointer' }}
                size={30}
                onClick={() => setModalVisible(!modalVisible)}
              />
            </S.Header>
            <S.Content>
              <S.ModalContent>
                <S.InputsWrapper>
                  <S.InputContainer>
                    <S.Label>Nome da categoria</S.Label>
                    <S.Input
                      value={newSegment}
                      onChange={(event) => setNewSegment(event.target.value)}
                      readOnly={modalType === 'addCategoryExercise'}
                    />
                  </S.InputContainer>
                  {modalType === 'addCategoryExercise' && (
                    <S.InputContainer>
                      <S.Label>Nome do tipo</S.Label>
                      <S.Input
                        value={newExercise}
                        onChange={(event) => setNewExercise(event.target.value)}
                      />
                    </S.InputContainer>
                  )}
                </S.InputsWrapper>
                <Button
                  textContent={`Criar ${
                    modalType === 'addCategoryExercise'
                      ? 'categoria'
                      : 'exercício'
                  }`}
                  variant="yellow"
                  onClick={handleClick}
                  textFont="13px"
                  extraStyles={{ height: '35px' }}
                />
              </S.ModalContent>
            </S.Content>
          </S.Container>
        </S.BackdropContainer>
      </>
    );
  },
);
